module.exports = __webpack_public_path__ + "img/icon-arrow-right-black.ca20ec65.svg";